import { createSlice } from "@reduxjs/toolkit";
import {
	getManageInternal,
	setManageInternal,
	removeManageInternal,
} from "../../lib/useLocalStorageInternal";

const initialState = {
	name: "",
	email: "",
	token: "",
	user: null,
	userRoles: [],
	corporateuser: 0,
};

// create a slice
const manageInternal = createSlice({
	name: "manageInternal",
	initialState: getManageInternal() ? getManageInternal() : initialState,
	reducers: {
		setInternal: (state, action) => {
			state = {
				...state,
				...action.payload,
			};
			setManageInternal(state);
		},
		resetInternal: (state) => {
			state = initialState;
			setManageInternal(state);
			removeManageInternal();
			return state;
		},
		setCorporateUser: (state, action) => {
			state.corporateuser = action.payload;
			setManageInternal(state);
		},
		getInternal: (state) => {
			state = getManageInternal();
			return state;
		},
	},
});

export default manageInternal.reducer;

export const {
	setInternal,
	resetInternal,
	getInternal,
	setCorporateUser,
} = manageInternal.actions;
